const CommonPath = [
  {
    path: "/",
    redirect: "/auth",
    auth: false,
    exact: true,
  },
  {
    component: "NotFound",
    path: "/not-found",
    componentPath: "pages/Notfound",
    name: "Notfound",
    auth: false,
    exact: true,
  },
  {
    path: "/notfound",
    redirect: "/notfound",
  },

  {
    component: "AuthLayout",
    path: "/notfound",
    auth: false,
    name: "PageNotFound",
    exact: true,
    redirect: "",
    childrens: [
      {
        component: "NotFound",
        path: "/not-found",
        componentPath: "pages/Notfound",
        name: "Notfound",
        auth: false,
        exact: true,
      },
    ],
  },
  {
    component: "ContractSuccess",
    path: "/success",
    componentPath: "pages/Auth/ContractSuccess",
    name: "ContractSuccess",
    auth: false,
    exact: true,
  },

  {
    component: "AuthLayout",
    path: "/auth",
    auth: false,
    name: "Auth",
    exact: false,
    redirect: "/auth/login",
    childrens: [
      {
        component: "Login",
        path: "/login",
        componentPath: "pages/Auth/Login",
        name: "Login",
        auth: false,
        exact: true,
      },
      {
        component: "Signup",
        path: "/signup",
        componentPath: "pages/Auth/Signup",
        name: "Signup",
        auth: false,
        exact: true,
      },
      {
        component: "LoginOtp",
        path: "/login/otp",
        componentPath: "pages/Auth/LoginOtp",
        name: "LoginOtp",
        auth: false,
        exact: true,
      },
      {
        component: "ForgetPassword",
        path: "/login/forgetPassword",
        componentPath: "pages/Auth/ForgetPassword",
        name: "ForgetPassword",
        auth: false,
        exact: true,
      },
      {
        component: "RestPassword",
        path: "/login/resetpassword",
        componentPath: "pages/Auth/RestPassword",
        name: "RestPassword",
        auth: false,
        exact: true,
      },
      {
        component: "CCGApproval",
        path: "/login/ccg-approval",
        componentPath: "pages/Auth/CCGApproval",
        name: "CCGApproval",
        auth: false,
        exact: true,
      },
      {
        component: "CCGApprovalTransaction",
        path: "/login/ccg-approval-agreement",
        componentPath: "pages/Auth/CCGApprovalTransaction",
        name: "CCGApprovalTransaction",
        auth: false,
        exact: true,
      },
      {
        component: "CCGApproval",
        path: "/login/addendum",
        componentPath: "pages/Auth/CCGApproval",
        name: "CCGApproval",
        auth: false,
        exact: true,
      },
      {
        component: "ContractSuccess",
        path: "/success",
        componentPath: "pages/Auth/ContractSuccess",
        name: "ContractSuccess",
        auth: false,
        exact: true,
      },
      {
        component: "Terms",
        path: "/terms",
        componentPath: "pages/Auth/TermsAndCondition",
        name: "Terms",
        auth: false,
        exact: true,
      },
      {
        component: "Privacypolicy",
        path: "/privacy-policy",
        componentPath: "pages/Auth/Privacy",
        name: "Privaypolicy",
        auth: false,
        exact: true,
      },
    ],
  },
];
export const routersAgent = [
  ...CommonPath,
  //agent
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "Agent",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        // componentPath: "pages/Dashboard/Agent/AgentDashboardPgae",
        // for release
        componentPath: "pages/Dashboard/Supplier/SupplierDashboardPage",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "AgentCommodityDepoist",
        path: "/commodity-deposits",
        componentPath:
          "pages/Dashboard/Agent/CommodityDepoist/AgentCommodityDepoist",
        name: "CommodityDeposits",
        auth: false,
        exact: true,
      },

      {
        component: "MyselfDepositPage",
        path: "/commodity-deposits/deposit",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/MyselfDeposit",
        name: "MyselfDepositPage",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewTruckPage",
        path: "/commodity-deposits/deposit/add-truck",
        componentPath: "pages/Dashboard/Supplier/CommodityDeposits/AddNewTruck",
        name: "AddNewTruckPage",
        auth: false,
        exact: true,
      },
      {
        component: "ConfirmDepositPage",
        path: "/commodity-deposits/deposit/confirm-deposit",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/ConfirmDeposit",
        name: "ConfirmDepositPage",
        auth: false,
        exact: true,
      },
      {
        component: "CreateCommodityDeposit",
        path: "/commodity-deposits/create-commodity-deposit",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/CreateCommodityDeposit",
        name: "CreateCommodityDeposit",
        auth: false,
        exact: true,
      },
      {
        component: "AssignAgentForm",
        path: "/commodity-deposits/assign-agent",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/AssignAgentForm",
        name: "AssignAgentForm",
        auth: false,
        exact: true,
      },
      {
        component: "WarehouseLayout",
        path: "/commodity-deposits/warehouse-layout",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/WareHouseLayout",
        name: "WarehouseLayout",
        auth: false,
        exact: true,
      },
      {
        component: "Completed",
        path: "/purchaseorders/completed",
        componentPath: "pages/Dashboard/Agent/PurchaseOrder/PurchaseCompleted",
        name: "Completed",
        auth: false,
        exact: true,
      },
      {
        component: "Ongoing",
        path: "/purchaseorders/ongoing",
        componentPath: "pages/Dashboard/Agent/PurchaseOrder/PurchaseOngoing",
        name: "Ongoing",
        auth: false,
        exact: true,
      },
      {
        component: "AgentDepositPage",
        path: "/commodity-deposits/agent-deposit",
        componentPath: "pages/Dashboard/Agent/PurchaseOrder/AgentDeposit",
        name: "AgentDepositPage",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewAgentPage",
        path: "/commodity-deposits/agent-deposit/add-agent",
        componentPath: "pages/Dashboard/Agent/PurchaseOrder/AddNewAgent",
        name: "AddNewAgentPage",
        auth: false,
        exact: true,
      },
      {
        component: "DepositRequestForm",
        path: "/dashboard/deposit-request",
        componentPath: "pages/Dashboard/Agent/DepositRequestForm",
        name: "DepositRequestForm",
        auth: false,
        exact: true,
      },
      {
        component: "ReleaseRequestForm",
        path: "/dashboard/release-request",
        componentPath: "pages/Dashboard/Agent/ReleaseRequestForm",
        name: "ReleaseRequestForm",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfilePageKYC",
        path: "/kycdetails",
        componentPath: "pages/Dashboard/User/MyProfileKYC",
        name: "MyProfilePageKYC",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routersSupplier = [
  ...CommonPath,
  //supplier
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "Supplier",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/Supplier/SupplierDashboardPage",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityDeposits",
        path: "/commodity-deposits",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/CommodityDeposits",
        name: "CommodityDeposits",
        auth: false,
        exact: true,
      },
      {
        component: "MyselfDepositPage",
        path: "/commodity-deposits/deposit",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/MyselfDeposit",
        name: "MyselfDepositPage",
        auth: false,
        exact: true,
      },
      {
        component: "AgentDepositPage",
        path: "/commodity-deposits/agent-deposit",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/AgentDeposit",
        name: "AgentDepositPage",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewAgentPage",
        path: "/commodity-deposits/agent-deposit/add-agent",
        componentPath: "pages/Dashboard/Supplier/CommodityDeposits/AddNewAgent",
        name: "AddNewAgentPage",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewTruckPage",
        path: "/commodity-deposits/deposit/add-truck",
        componentPath: "pages/Dashboard/Supplier/CommodityDeposits/AddNewTruck",
        name: "AddNewTruckPage",
        auth: false,
        exact: true,
      },
      {
        component: "ConfirmDepositPage",
        path: "/commodity-deposits/deposit/confirm-deposit",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/ConfirmDeposit",
        name: "ConfirmDepositPage",
        auth: false,
        exact: true,
      },
      {
        component: "CreateCommodityDeposit",
        path: "/commodity-deposits/create-commodity-deposit",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/CreateCommodityDeposit",
        name: "CreateCommodityDeposit",
        auth: false,
        exact: true,
      },
      {
        component: "AssignAgentForm",
        path: "/commodity-deposits/assign-agent",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/AssignAgentForm",
        name: "AssignAgentForm",
        auth: false,
        exact: true,
      },
      {
        component: "WarehouseLayout",
        path: "/commodity-deposits/warehouse-layout",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/WareHouseLayout",
        name: "WarehouseLayout",
        auth: false,
        exact: true,
      },
      {
        component: "WarehouseLayoutPage",
        path: "/purchase-order/warehouse-layout",
        componentPath:
          "pages/Dashboard/Supplier/PurchaseOrder/WarehouseLayoutPage",
        name: "WarehouseLayoutPage",
        auth: false,
        exact: true,
      },
      {
        component: "DownloadLedger",
        path: "/download-ledger",
        componentPath: "pages/Dashboard/Supplier/DownloadLedger",
        name: "DownloadLedger",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "Completed",
        path: "/purchaseorders/completed",
        componentPath:
          "pages/Dashboard/Supplier/PurchaseOrder/PurchaseCompleted",
        name: "Completed",
        auth: false,
        exact: true,
      },
      {
        component: "Ongoing",
        path: "/purchaseorders/ongoing",
        componentPath: "pages/Dashboard/Supplier/PurchaseOrder/PurchaseOngoing",
        name: "Ongoing",
        auth: false,
        exact: true,
      },
      {
        component: "PaymentTotalBill",
        path: "/payments/total-bill-raised",
        componentPath: "pages/Dashboard/Supplier/Payments/PaymentTotalBill",
        name: "PaymentTotalBill",
        auth: false,
        exact: true,
      },
      {
        component: "PaymentsOutstanding",
        path: "/payments/outstanding",
        componentPath: "pages/Dashboard/Supplier/Payments/PaymentsOutstanding",
        name: "PaymentsOutstanding",
        auth: false,
        exact: true,
      },
      {
        component: "PaymentQualitydiscount",
        path: "/payments/quality-quantity-discount",
        componentPath:
          "pages/Dashboard/Supplier/Payments/PaymentQualitydiscount",
        name: "PaymentQualitydiscount",
        auth: false,
        exact: true,
      },
      {
        component: "PurchaseOngoingCounterBid",
        path: "/purchaseorders/ongoing-counter",
        componentPath:
          "pages/Dashboard/Supplier/PurchaseOrder/PurchaseCounterBid",
        name: "PurchaseOngoingCounterBid",
        auth: false,
        exact: true,
      },
      {
        component: "BidQuotationRequest",
        path: "/bidQuotation/submittedBids",
        componentPath:
          "pages/Dashboard/Supplier/BidQuotationRequests/SubmittedBids",
        name: "SubmittedBidsPage",
        auth: false,
        exact: true,
      },
      {
        component: "BidQuotationRequest",
        path: "/bidQuotation/ongoingBids",
        componentPath:
          "pages/Dashboard/Supplier/BidQuotationRequests/OngoingBids",
        name: "OngoingBidsPage",
        auth: false,
        exact: true,
      },
      {
        component: "BidQuotationRequest",
        path: "/bidQuotation/ongoingBids/bidNow",
        componentPath:
          "pages/Dashboard/Supplier/BidQuotationRequests/BidNowForm",
        name: "BidNowFormPage",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfilePageKYC",
        path: "/kycdetails",
        componentPath: "pages/Dashboard/User/MyProfileKYC",
        name: "MyProfilePageKYC",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routers = [...CommonPath];

export const routersUsers = [
  ...CommonPath,
  //user
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "User",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/User/UserDashboardPage",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      // {
      //   component: "UserRequestList",
      //   path: "/user-requestList",
      //   componentPath: "pages/Dashboard/User/SubmitRequest/UserRequestList",
      //   name: "UserRequestList",
      //   auth: false,
      //   exact: true,
      // },
      {
        component: "WarehouseLayout",
        path: "/commodity-deposits/warehouse-layout",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/WareHouseLayout",
        name: "WarehouseLayout",
        auth: false,
        exact: true,
      },
      {
        component: "SubmitRequest",
        path: "/proposal-order/submit-request",
        componentPath: "pages/Dashboard/User/SubmitRequest/SubmitRequest",
        name: "SubmitRequest",
        auth: false,
        exact: true,
      },
      {
        component: "CompleteProfile",
        path: "/submit-request/complete-profile",
        componentPath: "pages/Dashboard/User/SubmitRequest/CompleteProfile",
        name: "CompleteProfile",
        auth: false,
        exact: true,
      },
      {
        component: "UploadAdditionalDoc",
        path: "/submit-request/additional-document",
        componentPath: "pages/Dashboard/User/SubmitRequest/UploadAdditionalDoc",
        name: "UploadAdditionalDoc",
        auth: false,
        exact: true,
      },
      {
        component: "PurchaseOrder",
        path: "/proposal-order",
        componentPath: "pages/Dashboard/User/PurchaseOrder/PurchaseOrder",
        name: "PurchaseOrder",
        auth: false,
        exact: true,
      },
      {
        component: "Agreements",
        path: "/documents/agreements",
        componentPath: "pages/Dashboard/User/DocumentPage/Agreements",
        name: "Agreements",
        auth: false,
        exact: true,
      },
      {
        component: "ReleasePdf",
        path: "/documents/release-pdf",
        componentPath: "pages/Dashboard/User/DocumentPage/ReleasePdf",
        name: "ReleasePdf",
        auth: false,
        exact: true,
      },
      {
        component: "ReleasePdfByID",
        path: "/documents/release-pdf/id",
        componentPath: "pages/Dashboard/User/DocumentPage/ReleasePdfByID",
        name: "ReleasePdfByID",
        auth: false,
        exact: true,
      },
      {
        component: "PurchaseOrders",
        path: "/reports/purchase-requests",
        componentPath: "pages/Dashboard/User/DocumentPage/PurchaseOrders",
        name: "PurchaseOrders",
        auth: false,
        exact: true,
      },
      {
        component: "ReleaseOrders",
        path: "/reports/release-orders",
        componentPath: "pages/Dashboard/User/DocumentPage/ReleaseOrders",
        name: "ReleaseOrders",
        auth: false,
        exact: true,
      },
      {
        component: "StoragePage",
        path: "/reports/storage",
        componentPath: "pages/Dashboard/User/DocumentPage/Storage",
        name: "StoragePage",
        auth: false,
        exact: true,
      },
      {
        component: "ReleaseRequests",
        path: "/reports/release-requests",
        componentPath: "pages/Dashboard/User/DocumentPage/ReleaseRequests",
        name: "ReleaseRequests",
        auth: false,
        exact: true,
      },
      {
        component: "History",
        path: "/transactions/history",
        componentPath: "pages/Dashboard/User/Transactions/History",
        name: "History",
        auth: false,
        exact: true,
      },
      {
        component: "Ongoing",
        path: "/transactions/ongoing",
        componentPath: "pages/Dashboard/User/Transactions/Ongoing",
        name: "Ongoing",
        auth: false,
        exact: true,
      },
      {
        component: "Purchase",
        path: "/transactions/purchase",
        componentPath: "pages/Dashboard/User/Transactions/Purchase/Purchase",
        name: "PurchasePage",
        auth: false,
        exact: true,
      },
      {
        component: "Purchase",
        path: "/transactions/purchase/purchase-request",
        componentPath:
          "pages/Dashboard/User/Transactions/Purchase/PlacePurchaseRequest",
        name: "PlacePurchaseRequestPage",
        auth: false,
        exact: true,
      },
      {
        component: "Purchase",
        path: "/transactions/purchase/purchase-request/create-purchase",
        componentPath:
          "pages/Dashboard/User/Transactions/Purchase/CreatePurchaseRequest",
        name: "CreatePurchaseRequestPage",
        auth: false,
        exact: true,
      },
      {
        component: "Purchase",
        path: "/transactions/purchase/purchase-request/purchase-confirm",
        componentPath:
          "pages/Dashboard/User/Transactions/Purchase/PurchaseConfirmation",
        name: "PurchaseConfirmationPage",
        auth: false,
        exact: true,
      },
      {
        component: "Purchase",
        path: "/transactions/purchase/purchase-request/purchase-confirm/payment",
        componentPath: "pages/Dashboard/User/Transactions/Purchase/Payment",
        name: "PaymentPage",
        auth: false,
        exact: true,
      },
      {
        component: "Purchase",
        path: "/transactions/purchase/purchase-request/purchase-confirm/offline-payment",
        componentPath:
          "pages/Dashboard/User/Transactions/Purchase/OfflinePayment",
        name: "OfflinePaymentPage",
        auth: false,
        exact: true,
      },
      {
        component: "Storage",
        path: "/transactions/storage",
        componentPath: "pages/Dashboard/User/Transactions/Storage/Storage",
        name: "Storage",
        auth: false,
        exact: true,
      },
      {
        component: "StoragePurchaseCardPage",
        path: "/transactions/storage-details",
        componentPath:
          "pages/Dashboard/User/Transactions/Storage/StoragePurchaseCardPage",
        name: "StoragePurchaseCardPage",
        auth: false,
        exact: true,
      },
      {
        component: "CreateRelease",
        path: "/transactions/storage/create-release-request",
        componentPath:
          "pages/Dashboard/User/Transactions/Storage/CreateRelease",
        name: "CreateRelease",
        auth: false,
        exact: true,
      },
      {
        component: "ReleaseOfflinePayments",
        path: "/transactions/storage/create-release-request/offlinepayments",
        componentPath:
          "pages/Dashboard/User/Transactions/Storage/ReleaseOfflinePayments",
        name: "ReleaseOfflinePayments",
        auth: false,
        exact: true,
      },
      {
        component: "Release",
        path: "/transactions/release",
        componentPath: "pages/Dashboard/User/Transactions/Release/Release",
        name: "Release",
        auth: false,
        exact: true,
      },
      {
        component: "thirdPartyByRequest",
        path: "/transactions/thirdPartyByRequest",
        componentPath:
          "pages/Dashboard/User/Transactions/ThirdPartyByRequest/ThirdPartyByRequest",
        name: "thirdPartyByRequest",
        auth: false,
        exact: true,
      },

      {
        component: "ReleaseOrder",
        path: "/transactions/release/release-order",
        componentPath: "pages/Dashboard/User/Transactions/Release/ReleaseOrder",
        name: "ReleaseOrder",
        auth: false,
        exact: true,
      },
      {
        component: "GenerateReleaseOrderPage",
        path: "/transactions/release/release-order/commodity-release",
        componentPath:
          "pages/Dashboard/User/Transactions/Release/GenerateReleaseOrderPage",
        name: "GenerateReleaseOrderPage",
        auth: false,
        exact: true,
      },
      {
        component: "ReleaseRequestCompletedPage",
        path: "/transactions/release/release-request/commodity-release",
        componentPath:
          "pages/Dashboard/User/Transactions/Release/ReleaseRequestCompletedForm",
        name: "ReleaseRequestCompletedPage",
        auth: false,
        exact: true,
      },
      {
        component: "GenerateThirdPartyOrderPage",
        path: "/transactions/thirdPartyByRequest/commodity-release",
        componentPath:
          "pages/Dashboard/User/Transactions/ThirdPartyByRequest/GenerateThirdPartyOrderPage",
        name: "GenerateThirdPartyOrderPage",
        auth: false,
        exact: true,
      },
      // {
      //   component: "AddNewAgentPage",
      //   path: "/release/agent-deposit/add-agent",
      //   componentPath: "pages/releasePages/AddNewAgentPage",
      //   name: "AddNewAgentPage",
      //   auth: false,
      //   exact: true,
      // },
      {
        component: "AddReleaseAgentFromPage",
        path: "/release/agent-deposit/add-agent",
        componentPath: "pages/releasePages/AddReleaseAgentFromPage", //release_module_data
        name: "AddReleaseAgentFromPage",
        auth: false,
        exact: true,
      },
      {
        component: "AgentDepositPage",
        path: "/release/agent-deposit",
        componentPath: "pages/releasePages/AgentRelease",
        name: "AgentRelease",
        auth: false,
        exact: true,
      },
      {
        component: "CreateRelease",
        path: "/transactions/release/create-release-request",
        componentPath:
          "pages/Dashboard/User/Transactions/Storage/CreateRelease",
        name: "CreateRelease",
        auth: false,
        exact: true,
      },
      {
        component: "MyselfDepositPage",
        path: "/release-request",
        componentPath: "pages/releasePages/MyselfReleasePage",
        name: "MyselfReleasePage",
        auth: false,
        exact: true,
      },
      {
        component: "Payments",
        path: "/transactions/release/create-release-request/payments",
        componentPath: "pages/Dashboard/User/Payments/Payments",
        name: "Payments",
        auth: false,
        exact: true,
      },
      {
        component: "ReleaseOfflinePayments",
        path: "/transactions/release/create-release-request/offlinepayments",
        componentPath:
          "pages/Dashboard/User/Transactions/Storage/ReleaseOfflinePayments",
        name: "ReleaseOfflinePayments",
        auth: false,
        exact: true,
      },
      {
        component: "ThirdPartySale",
        path: "/transactions/release/third-part-sale",
        componentPath:
          "pages/Dashboard/User/Transactions/Release/ThirdPartySale",
        name: "ThirdPartySale",
        auth: false,
        exact: true,
      },
      {
        component: "NewThirdPartyCustomer",
        path: "/transactions/release/third-part-sale/new-customer",
        componentPath:
          "pages/Dashboard/User/Transactions/Release/NewThirdPartyCustomer",
        name: "NewThirdPartyCustomer",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityWithdrawal",
        path: "/transactions/release/commodity-withdrawal",
        componentPath:
          "pages/Dashboard/User/Transactions/Release/CommodityWithdrawal",
        name: "CommodityWithdrawal",
        auth: false,
        exact: true,
      },
      {
        component: "Payments",
        path: "/payments",
        componentPath: "pages/Dashboard/User/Payments/Payments",
        name: "Payments",
        auth: false,
        exact: true,
      },
      {
        component: "OfflinePayment",
        path: "/payments/offline-payment",
        componentPath: "pages/Dashboard/User/Payments/OfflinePayment",
        name: "OfflinePayment",
        auth: false,
        exact: true,
      },
      {
        component: "DownloadLedger",
        path: "/download-ledger",
        componentPath: "pages/Dashboard/User/DownloadLedger",
        name: "DownloadLedger",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfilePageKYC",
        path: "/kycdetails",
        componentPath: "pages/Dashboard/User/MyProfileKYC",
        name: "MyProfilePageKYC",
        auth: false,
        exact: true,
      },
      {
        component: "WarehousePage",
        path: "/warehouses",
        componentPath: "pages/Dashboard/User/WareHouse/WarehousePage",
        name: "warehouses",
        auth: false,
        exact: true,
      },
      {
        component: "BankingPage",
        path: "/bank",
        componentPath: "pages/Dashboard/User/Banks/Banking",
        name: "bank",
        auth: false,
        exact: true,
      },
      {
        component: "CustomerCommodityPage",
        path: "/warehouseCommodity",
        componentPath: "pages/Dashboard/User/CustomerCommodityPage",
        name: "CustomerCommodityPage",
        auth: false,
        exact: true,
      },
      {
        component: "CustomerLocationPage",
        path: "/warehouseLocation",
        componentPath: "pages/Dashboard/User/CustomerLocationPage",
        name: "CustomerLocationPage",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routersBusinessDev = [
  ...CommonPath,
  //bde
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "Business",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/Business/BusinessDashboard",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "SubmitRequest",
        path: "/submit-request",
        componentPath: "pages/Dashboard/Business/SubmitRequest/SubmitRequest",
        name: "SubmitRequest",
        auth: false,
        exact: true,
      },
      {
        component: "SubmitRequestForm",
        path: "/submit-request/submit-request-form",
        componentPath:
          "pages/Dashboard/Business/SubmitRequest/SubmitRequestForm",
        name: "SubmitRequestForm",
        auth: false,
        exact: true,
      },
      {
        component: "PurchaseOrders",
        path: "/purchase-orders",
        componentPath: "pages/Dashboard/Business/PurchaseOrders/PurchaseOrders",
        name: "PurchaseOrders",
        auth: false,
        exact: true,
      },
      {
        component: "ReleaseOrder",
        path: "/release-order",
        componentPath: "pages/Dashboard/Business/ReleaseOrder/ReleaseOrder",
        name: "ReleaseOrder",
        auth: false,
        exact: true,
      },
      {
        component: "ReleaseDetails",
        path: "/release-order/release-details",
        componentPath: "pages/Dashboard/Business/ReleaseOrder/ReleaseDetails",
        name: "ReleaseDetails",
        auth: false,
        exact: true,
      },
      {
        component: "ReleaseStorageDetails",
        path: "/release-order/storage-details",
        componentPath:
          "pages/Dashboard/Business/ReleaseOrder/ReleaseStorageDetails",
        name: "ReleaseStorageDetails",
        auth: false,
        exact: true,
      },
      {
        component: "Storage",
        path: "/release-order/customers/storage-details",
        componentPath: "pages/Dashboard/Business/Storage/Storage",
        name: "Storage",
        auth: false,
        exact: true,
      },
      {
        component: "CreateRelease",
        path: "/customer/storage-details/create-release-request",
        componentPath: "pages/Dashboard/Business/Storage/CreateRelease",
        name: "CreateRelease",
        auth: false,
        exact: true,
      },
      {
        component: "ConditionalApproval",
        path: "/conditional-approval",
        componentPath:
          "pages/Dashboard/Business/PurchaseOrders/ConditionalApproval",
        name: "ConditionalApproval",
        auth: false,
        exact: true,
      },
      {
        component: "Customer",
        path: "/onBoardings/customer",
        componentPath: "pages/Dashboard/Business/OnBoardings/Customer/Customer",
        name: "Customer",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewCustomer",
        path: "/onBoardings/customer/add-new-customer",
        componentPath:
          "pages/Dashboard/Business/OnBoardings/Customer/AddNewCustomer",
        name: "AddNewCustomer",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfilePageKYC",
        path: "/kycdetails",
        componentPath: "pages/Dashboard/User/MyProfileKYC",
        name: "MyProfilePageKYC",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routersCog = [
  ...CommonPath,
  //Cog
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "COG",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/Cog/COGDashBoard",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "RequestsSubmitted",
        path: "/value-chain-manage/requests-submitted",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/RequestsSubmitted",
        name: "RequestsSubmitted",
        auth: false,
        exact: true,
      },
      {
        component: "Addendum",
        path: "/value-chain-manage/addendum",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/Addendum",
        name: "Addendum",
        auth: false,
        exact: true,
      },
      {
        component: "GenerateAddendum",
        path: "/value-chain-manage/addendum/generate",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/GenerateAddendum",
        name: "GenerateAddendum",
        auth: false,
        exact: true,
      },
      {
        component: "SupplierBids",
        path: "/value-chain-manage/supplier-bids",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/SupplierBids",
        name: "SupplierBids",
        auth: false,
        exact: true,
      },
      {
        component: "DepositUpdates",
        path: "/value-chain-manage/deposit-updates",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/DepositUpdates",
        name: "DepositUpdates",
        auth: false,
        exact: true,
      },
      {
        component: "EditDepositUpdate",
        path: "/value-chain-manage/deposit-updates/edit-deposit-update",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/EditDepositUpdate",
        name: "EditDepositUpdate",
        auth: false,
        exact: true,
      },
      {
        component: "AllTransactions",
        path: "/value-chain-manage/alltransactions",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/AllTransactions",
        name: "alltransactions",
        auth: false,
        exact: true,
      },
      {
        component: "AllDetailsTransaction",
        path: "/value-chain-manage/alltransactionsdetails",
        componentPath:
          "pages/Dashboard/Cog/ValueChainManage/AllDetailsTransaction",
        name: "AllDetailsTransaction",
        auth: false,
        exact: true,
      },
      {
        component: "ValueChainManage",
        path: "/value-chain-manage/approvals",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/Vcm",
        name: "ValueChainManage",
        auth: false,
        exact: true,
      },
      {
        component: "ValueChainManage",
        path: "/value-chain-manage/purchase-request",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/PurchaseRequest",
        name: "PurchaseRequestPage",
        auth: false,
        exact: true,
      },
      {
        component: "ValueChainManage",
        path: "/value-chain-manage/purchase-request/initiate-bid",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/AddInitiateBid",
        name: "AddInitiateBid",
        auth: false,
        exact: true,
      },
      {
        component: "ValueChainManage",
        path: "/value-chain-manage/purchase-request/comparitive-sheet",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/ComparitiveSheet",
        name: "ComparitiveSheetPage",
        auth: false,
        exact: true,
      },
      {
        component: "ValueChainManage",
        path: "/value-chain-manage/purchase-request/bid-details",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/BidDetails",
        name: "BidDetailsPage",
        auth: false,
        exact: true,
      },
      {
        component: "ValueChainManage",
        path: "/value-chain-manage/purchase-request/bid-details/negotaite-bid",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/NegotiateBid",
        name: "NegotiateBid",
        auth: false,
        exact: true,
      },
      {
        component: "ValueChainManage",
        path: "/value-chain-manage/proposal-edit",
        componentPath: "pages/Dashboard/Cog/ValueChainManage/proposalEditForm",
        name: "ProposalEditForm",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfilePageKYC",
        path: "/kycdetails",
        componentPath: "pages/Dashboard/User/MyProfileKYC",
        name: "MyProfilePageKYC",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routersSuperAdmin = [
  ...CommonPath,
  //SuperAdmin
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "SuperAdmin",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/SuperAdmin/SuperAdminDashboard",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "Agreements",
        path: "/agreements",
        componentPath: "pages/Dashboard/SuperAdmin/Agreements/Agreements",
        name: "Agreements",
        auth: false,
        exact: true,
      },
      {
        component: "VerifyAgreements",
        path: "/agreements/verify-agreements",
        componentPath: "pages/Dashboard/SuperAdmin/Agreements/VerifyAgreements",
        name: "VerifyAgreements",
        auth: false,
        exact: true,
      },

      {
        component: "PendingApproval",
        path: "/pending-approval",
        componentPath: "pages/Dashboard/SuperAdmin/PendingApproval",
        name: "PendingApproval",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewLocation",
        path: "/onboardings/location/add-new-location",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/AddNewLocation",
        name: "AddNewLocation",
        auth: false,
        exact: true,
      },
      {
        component: "AddCommodities",
        path: "/onboardings/commodities/add-commodities",
        componentPath:
          "pages/Dashboard/ClusterManager/OnBoardings/AddCommodities",
        name: "AddCommodities",
        auth: false,
        exact: true,
      },
      {
        component: "TeamMembers",
        path: "/team-members",
        componentPath: "pages/Dashboard/SuperAdmin/TeamMembers/TeamMembers",
        name: "TeamMembers",
        auth: false,
        exact: true,
      },
      {
        component: "WarehouseLayout",
        path: "/commodity-deposits/warehouse-layout",
        componentPath:
          "pages/Dashboard/Supplier/CommodityDeposits/WareHouseLayout",
        name: "WarehouseLayout",
        auth: false,
        exact: true,
      },
      {
        component: "CreateTeamMember",
        path: "/team-members/create-team-member",
        componentPath:
          "pages/Dashboard/SuperAdmin/TeamMembers/CreateTeamMember",
        name: "CreateTeamMember",
        auth: false,
        exact: true,
      },
      {
        component: "ViewMember",
        path: "/team-members/view-team-member",
        componentPath: "pages/Dashboard/SuperAdmin/TeamMembers/ViewMember",
        name: "ViewMember",
        auth: false,
        exact: true,
      },
      {
        component: "OnBoards",
        path: "/onboards",
        componentPath: "pages/Dashboard/SuperAdmin/OnBoards/Onboards",
        name: "OnBoards",
        auth: false,
        exact: true,
      },
      {
        component: "LocationView",
        path: "/onboards/location-views",
        componentPath: "pages/Dashboard/SuperAdmin/OnBoards/LocationView",
        name: "LocationView",
        auth: false,
        exact: true,
      },
      {
        component: "CustomerView",
        path: "/onboards/customer-view",
        componentPath: "pages/Dashboard/SuperAdmin/OnBoards/CustomerView",
        name: "CustomerView",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewCustomer",
        path: "/onboards/add-new-customer",
        componentPath:
          "pages/Dashboard/SuperAdmin/AddNewCustomer/AddNewCustomer",
        name: "AddNewCustomer",
        auth: false,
        exact: true,
      },

      // {
      //   component: "Signup",
      //   path: "/onboards/add-new-customers",
      //   componentPath:
      //     "pages/Dashboard/SuperAdmin/AddNewCustomer/AddNewCustomer",

      //   name: "Signup",
      //   auth: false,
      //   exact: true,
      // },

      {
        component: "Ticket",
        path: "/ticket",
        componentPath: "pages/Dashboard/SuperAdmin/Ticket/Ticket",
        name: "Ticket",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewTicket",
        path: "/ticket/add-new-ticket",
        componentPath: "pages/Dashboard/SuperAdmin/Ticket/AddNewTicket",
        name: "AddNewTicket",
        auth: false,
        exact: true,
      },
      {
        component: "DepositedCommodities",
        path: "/deposited-commodities",
        componentPath:
          "pages/Dashboard/SuperAdmin/DepositedCommodities/DepositedCommodities",
        name: "DepositedCommodities",
        auth: false,
        exact: true,
      },
      {
        component: "ViewDepositedCommodities",
        path: "/deposited-commodities/view",
        componentPath:
          "pages/Dashboard/SuperAdmin/DepositedCommodities/ViewDepositedCommodities",
        name: "ViewDepositedCommodities",
        auth: false,
        exact: true,
      },
      {
        component: "ValueChainManagement",
        path: "/value-chain-management",
        componentPath:
          "pages/Dashboard/SuperAdmin/ValueChainManagement/ValueChainManagement",
        name: "ValueChainManagement",
        auth: false,
        exact: true,
      },
      {
        component: "SubmittedRequests",
        path: "/value-chain-management/submitted-requests",
        componentPath:
          "pages/Dashboard/SuperAdmin/ValueChainManagement/SubmittedRequests/SubmittedRequests",
        name: "SubmittedRequests",
        auth: false,
        exact: true,
      },
      {
        component: "ViewProposals",
        path: "/value-chain-management/submitted-requests/view-proposals",
        componentPath:
          "pages/Dashboard/SuperAdmin/ValueChainManagement/SubmittedRequests/ViewProposals",
        name: "ViewProposals",
        auth: false,
        exact: true,
      },
      {
        component: "Documents",
        path: "/value-chain-management/documents",
        componentPath:
          "pages/Dashboard/SuperAdmin/ValueChainManagement/Documents",
        name: "Documents",
        auth: false,
        exact: true,
      },
      {
        component: "Transactions",
        path: "/value-chain-management/transactions",
        componentPath:
          "pages/Dashboard/SuperAdmin/ValueChainManagement/Transactions",
        name: "Transactions",
        auth: false,
        exact: true,
      },
      {
        component: "Payments",
        path: "/value-chain-management/payments",
        componentPath:
          "pages/Dashboard/SuperAdmin/ValueChainManagement/Payments",
        name: "Payments",
        auth: false,
        exact: true,
      },
      {
        component: "Ledgers",
        path: "/value-chain-management/ledgers",
        componentPath:
          "pages/Dashboard/SuperAdmin/ValueChainManagement/Ledgers",
        name: "Ledgers",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfilePageKYC",
        path: "/kycdetails",
        componentPath: "pages/Dashboard/User/MyProfileKYC",
        name: "MyProfilePageKYC",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routersQualityManager = [
  ...CommonPath,
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "QualityManager",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      {
        component: "QualityManager",
        path: "/dashboard",
        // componentPath: "pages/Dashboard/QualityManager/QualityManager",
        // for release
        componentPath: "pages/Dashboard/GrainManager/GrainManagerDashboardPage",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "PendingTasks",
        path: "/pending-tasks",
        componentPath: "pages/Dashboard/QualityManager/QualityManager",
        name: "PendingTasks",
        auth: false,
        exact: true,
      },
      {
        component: "AddQualityTestDetails",
        path: "/dashboard/quality-test-details-view",
        componentPath: "pages/Dashboard/QualityManager/AddQualityTestDetails",
        name: "AddQualityTestDetails",
        auth: false,
        exact: true,
      },
      {
        component: "QualityTestDetailsSend",
        path: "/dashboard/quality-test-details-check",

        componentPath: "pages/Dashboard/QualityManager/QualityTestDetailsSend",
        name: "QualityTestDetailsSend",
        auth: false,
        exact: true,
      },
      {
        component: "OnSpotAndLabTestDetail",
        path: "/dashboard/onspotandlab-test-details",

        componentPath: "pages/Dashboard/QualityManager/OnSpotAndLabTestDetails",
        name: "OnSpotAndLabTestDetails",
        auth: false,
        exact: true,
      },
      {
        component: "EditQualityTestDetail",
        path: "/dashboard/edit-quality-test-details",

        componentPath: "pages/Dashboard/QualityManager/EditQualityTestDetail",
        name: "EditQualityTestDetail",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routersGrainManager = [
  ...CommonPath,
  //GrainManager
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "GrainManager",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/GrainManager/GrainManagerDashboardPage",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "Bookings",
        path: "/bookings",
        componentPath: "pages/Dashboard/GrainManager/Bookings/Bookings",
        name: "Bookings",
        auth: false,
        exact: true,
      },

      {
        component: "Bookings",
        path: "/bookings/newBooking",
        componentPath:
          "pages/Dashboard/GrainManager/Bookings/CreateNewBooking/CreateNewBooking",
        name: "CreateNewBooking",
        auth: false,
        exact: true,
      },
      {
        component: "Maintenance",
        path: "/maintenance",
        componentPath: "pages/Dashboard/GrainManager/Maintenance",
        name: "AddNewMaintenance",
        auth: false,
        exact: true,
      },
      {
        component: "AddMaintenanceRequest",
        path: "/maintenance/addrequest",
        componentPath: "pages/Dashboard/GrainManager/AddNewMaintenance",
        name: "GenerateAddendum",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityDeposits",
        path: "/commodity-deposits",
        componentPath:
          "pages/Dashboard/GrainManager/CommodityDepoist/CommodityDeposits",
        name: "CommodityDeposits",
        auth: false,
        exact: true,
      },
      {
        component: "GrainTruckDetails",
        path: "/commodity-deposits/add-truck",
        componentPath:
          "pages/Dashboard/GrainManager/CommodityDepoist/GrainTruckDetails",
        name: "GrainTruckDetails",
        auth: false,
        exact: true,
      },

        {
        component: "ReleaseTruckDetails",
        path: "/release-request",
        componentPath:
          "pages/Dashboard/GrainManager/ReleaseTruckDetails",
        name: "ReleaseTruckDetails",
        auth: false,
        exact: true,
      },

      {
        component: "CommodityDepoistReleaseDetails",
        path: "/commodity-deposits/release-details",
        componentPath:
          "pages/Dashboard/GrainManager/CommodityDepoist/CommodityDepoistReleaseDetails",
        name: "CommodityDepoistReleaseDetails",
        auth: false,
        exact: true,
      },
      {
        component: "AddCommodityQuality",
        path: "/commodity-deposits/quality-form",
        componentPath:
          "pages/Dashboard/GrainManager/CommodityDepoist/AddCommodityQuality",
        name: "AddCommodityQuality",
        auth: false,
        exact: true,
      },

      {
        component: "DigitalSignaturePage",
        path: "/commodity-release/digital-signature",
        componentPath:
          "pages/Dashboard/GrainManager/DigitalSignaturePage/DigitalSignaturePage",
        name: "DigitalSignaturePage",
        auth: false,
        exact: true,
      },
      {
        component: "AddCommodityTruckDetails",
        path: "/commodity-deposits/booking-form",
        componentPath:
          "pages/Dashboard/GrainManager/CommodityDepoist/AddCommodityTruckDetails",
        name: "AddCommodityTruckDetails",
        auth: false,
        exact: true,
      },
      {
        component: "AddCommodityDetails",
        path: "/commodity-release/commodity-details",
        componentPath:
          "pages/Dashboard/GrainManager/CommodityDepoist/AddCommodityDetails",
        name: "AddCommodityDetails",
        auth: false,
        exact: true,
      },
      {
        component: "AddCommodityReleaseTruckDetailsPages",
        path: "/commodity-release/booking-form",
        componentPath:
          "pages/Dashboard/GrainManager/CommodityDepoist/AddCommodityReleaseTruckDetailsPages",
        name: "AddCommodityReleaseTruckDetailsPages",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityFinalWeighment",
        path: "/commodity-deposits/final-weighment-form",
        componentPath:
          "pages/Dashboard/GrainManager/CommodityDepoist/CommodityFinalWeighment",
        name: "CommodityFinalWeighment",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityFinalReleaseWeighment",
        path: "/commodity-release/final-weighment-form",
        componentPath:
          "pages/Dashboard/GrainManager/CommodityDepoist/CommodityFinalReleaseWeighment",
        name: "CommodityFinalReleaseWeighment",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityHealth",
        path: "/commodity-health",
        componentPath: "pages/Dashboard/GrainManager/CommodityHealth",
        name: "CommodityHealth",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityRelease",
        path: "/commodity-release",
        componentPath: "pages/Dashboard/GrainManager/CommodityRelease",
        name: "CommodityRelease",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityReleaseDetails",
        path: "/commodity-release/release-details",
        componentPath: "pages/Dashboard/GrainManager/CommodityReleaseDetails",
        name: "CommodityReleaseDetails",
        auth: false,
        exact: true,
      },

      {
        component: "FumigationAndSpraying",
        path: "/fumigation-and-spraying",
        componentPath: "pages/Dashboard/GrainManager/FumigationAndSpraying",
        name: "FumigationAndSpraying",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewFumigationAndSpraying",
        path: "/fumigation-and-spraying/add-new-request",
        componentPath: "pages/Dashboard/GrainManager/AddNewFumigation",
        name: "AddNewFumigationAndSpraying",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfilePageKYC",
        path: "/kycdetails",
        componentPath: "pages/Dashboard/User/MyProfileKYC",
        name: "MyProfilePageKYC",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routersAreaManager = [
  ...CommonPath,
  //AreaManager
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "AreaManager",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/AreaManager/AreaManagerDashboard",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "Approvals",
        path: "/approvals",
        componentPath: "pages/Dashboard/AreaManager/Approvals/Approvals",
        name: "Approvals",
        auth: false,
        exact: true,
      },
      {
        component: "CreateSubmitRequestPage",
        path: "/proposal-submission/create-submit-request",
        componentPath:
          "pages/Dashboard/AreaManager/ProposalSubmission/CreateSubmitRequestPage",
        name: "CreateSubmitRequestPage",
        auth: false,
        exact: true,
      },
      {
        component: "Approvals",
        path: "/approvals/retail-depositor",
        componentPath:
          "pages/Dashboard/AreaManager/Approvals/ApprovalsSub/RetailDepositors",
        name: "RetailDepositorsPage",
        auth: false,
        exact: true,
      },
      {
        component: "Approvals",
        path: "/approvals/warehouse-location",
        componentPath:
          "pages/Dashboard/AreaManager/Approvals/ApprovalsSub/WarehouseLocation",
        name: "WarehouseLocationPage",
        auth: false,
        exact: true,
      },
      {
        component: "Approvals",
        path: "/approvals/fumigation-activity",
        componentPath:
          "pages/Dashboard/AreaManager/Approvals/ApprovalsSub/FumigationClusterManager",
        name: "FumigationClusterManagerPage",
        auth: false,
        exact: true,
      },
      {
        component: "Approvals",
        path: "/approvals/new-commodity",
        componentPath:
          "pages/Dashboard/AreaManager/Approvals/ApprovalsSub/NewCommodity",
        name: "NewCommodityPage",
        auth: false,
        exact: true,
      },
      {
        component: "Approvals",
        path: "/approvals/contract-mapping",
        componentPath:
          "pages/Dashboard/AreaManager/Approvals/ApprovalsSub/ContractMapping",
        name: "ContractMappingPage",
        auth: false,
        exact: true,
      },
      {
        component: "Approvals",
        path: "/approvals/security-agency",
        componentPath:
          "pages/Dashboard/AreaManager/Approvals/ApprovalsSub/SecurityAgency",
        name: "SecurityAgencyPage",
        auth: false,
        exact: true,
      },
      {
        component: "Approvals",
        path: "/approvals/commercials-team",
        componentPath:
          "pages/Dashboard/AreaManager/Approvals/ApprovalsSub/CommercialTeams",
        name: "CommercialTeamsPage",
        auth: false,
        exact: true,
      },
      {
        component: "Approvals",
        path: "/approvals/submit-proposal",
        componentPath:
          "pages/Dashboard/AreaManager/Approvals/ApprovalsSub/SubmitProposal",
        name: "SubmitProposalPage",
        auth: false,
        exact: true,
      },
      {
        component: "ClusterManager",
        path: "/onboardings/cluster-manager",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/ClusterManager",
        name: "ClusterManager",
        auth: false,
        exact: true,
      },
      {
        component: "AddClusterManager",
        path: "/onboardings/cluster-manager/add-cluster-manager",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/AddClusterManager",
        name: "AddClusterManager",
        auth: false,
        exact: true,
      },
      {
        component: "Customer",
        path: "/onboardings/customer",
        componentPath: "pages/Dashboard/AreaManager/OnBoarding/Customer",
        name: "Customer",
        auth: false,
        exact: true,
      },
      {
        component: "Locations",
        path: "/onboardings/locations",
        componentPath: "pages/Dashboard/AreaManager/OnBoarding/Locations",
        name: "Locations",
        auth: false,
        exact: true,
      },
      {
        component: "AddLocation",
        path: "/onboardings/locations/add",
        componentPath: "pages/Dashboard/AreaManager/OnBoarding/AddLocation",
        name: "AddLocation",
        auth: false,
        exact: true,
      },
      {
        component: "Commodities",
        path: "/onboardings/commodities",
        componentPath: "pages/Dashboard/AreaManager/OnBoarding/Commodities",
        name: "Commodities",
        auth: false,
        exact: true,
      },
      {
        component: "AddCommodities",
        path: "/onboardings/commodities/add-commodities",
        componentPath: "pages/Dashboard/AreaManager/OnBoarding/AddCommodities",
        name: "AddCommodities",
        auth: false,
        exact: true,
      },
      {
        component: "BDE",
        path: "/onboardings/business-devolpment-exective",
        componentPath:
          "pages/Dashboard/AreaManager/OnBoarding/BusinessDevolpmentExecutive",
        name: "BDE",
        auth: false,
        exact: true,
      },
      {
        component: "AddBDE",
        path: "/onboardings/bde/add-bde",
        componentPath:
          "pages/Dashboard/AreaManager/OnBoarding/AddBusinessDevolpmentExecutive",
        name: "AddBusinessDevolpmentExecutive",
        auth: false,
        exact: true,
      },

      {
        component: "GrainManager",
        path: "/onboardings/grain-manager",
        componentPath: "pages/Dashboard/AreaManager/OnBoarding/GrainManager",
        name: "GrainManager",
        auth: false,
        exact: true,
      },

      {
        component: "AddNewCustomer",
        path: "/onboardings/customer/add-new-customer",
        componentPath: "pages/Dashboard/AreaManager/OnBoarding/AddNewCustomer",
        name: "AddNewCustomer",
        auth: false,
        exact: true,
      },
      {
        component: "ProposalSubmission",
        path: "/proposal-submission",
        componentPath:
          "pages/Dashboard/AreaManager/ProposalSubmission/ProposalSubmission",
        name: "ProposalSubmission",
        auth: false,
        exact: true,
      },
      {
        component: "SubmitRequestPage",
        path: "/submit-request",
        componentPath:
          "pages/Dashboard/AreaManager/ProposalSubmission/SubmitRequestPage",
        name: "SubmitRequestPage",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewGrainManager",
        path: "/onboardings/grain-manager/add-new-grain-manager",
        componentPath:
          "pages/Dashboard/AreaManager/OnBoarding/AddNewGrainManager",
        name: "AddNewGrainManager",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfilePageKYC",
        path: "/kycdetails",
        componentPath: "pages/Dashboard/User/MyProfileKYC",
        name: "MyProfilePageKYC",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routersZonalManager = [
  ...CommonPath,
  //GrainManager
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "ZonalManager",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/ZonalManager/ZonalManagerDashBoard",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "Ticket",
        path: "/ticket",
        componentPath: "pages/Dashboard/ZonalManager/Ticket",
        name: "Ticket",
        auth: false,
        exact: true,
      },
      {
        component: "ClusterManager",
        path: "/onboardings/cluster-manager",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/ClusterManager",
        name: "ClusterManager",
        auth: false,
        exact: true,
      },
      {
        component: "BDE",
        path: "/onboardings/business-devolpment-exective",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/BusinessDevolpmentExecutive",
        name: "BDE",
        auth: false,
        exact: true,
      },
      {
        component: "AddBDE",
        path: "/onboardings/bde/add-bde",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/AddBusinessDevolpmentExecutive",
        name: "AddBusinessDevolpmentExecutive",
        auth: false,
        exact: true,
      },
      {
        component: "Commodities",
        path: "/onboardings/commodities",
        componentPath: "pages/Dashboard/ZonalManager/OnBoardings/Commodities",
        name: "Commodities",
        auth: false,
        exact: true,
      },
      {
        component: "AddCommodities",
        path: "/onboardings/commodities/add-commodities",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/AddCommodities",
        name: "AddCommodities",
        auth: false,
        exact: true,
      },
      {
        component: "AddClusterManager",
        path: "/onboardings/cluster-manager/add-cluster-manager",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/AddClusterManager",
        name: "AddClusterManager",
        auth: false,
        exact: true,
      },
      {
        component: "AreaManager",
        path: "/onboardings/area-manager",
        componentPath: "pages/Dashboard/ZonalManager/OnBoardings/AreaManager",
        name: "AreaManager",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewAreaManager",
        path: "/onboardings/area-manager/add-new-area-manager",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/AddNewAreaManager",
        name: "AddNewAreaManager",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/onboardings/location",
        componentPath: "pages/Dashboard/ZonalManager/OnBoardings/Location",
        name: "Location",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewLocation",
        path: "/onboardings/location/add-new-location",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/AddNewLocation",
        name: "AddNewLocation",
        auth: false,
        exact: true,
      },
      {
        component: "Customer",
        path: "/onboardings/customer",
        componentPath: "pages/Dashboard/ZonalManager/OnBoardings/Customer",
        name: "Customer",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewCustomer",
        path: "/onboardings/customer/add-new-customer",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/AddNewCustomer",
        name: "AddNewCustomer ",
        auth: false,
        exact: true,
      },
      {
        component: "Supplier",
        path: "/onboardings/supplier",
        componentPath: "pages/Dashboard/ZonalManager/OnBoardings/Supplier",
        name: "Supplier",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewSupplier",
        path: "/onboardings/supplier/add-new-supplier",
        componentPath:
          "pages/Dashboard/ZonalManager/OnBoardings/AddNewSupplier",
        name: "AddNewSupplier",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfilePageKYC",
        path: "/kycdetails",
        componentPath: "pages/Dashboard/User/MyProfileKYC",
        name: "MyProfilePageKYC",
        auth: false,
        exact: true,
      },
    ],
  },
];
export const routersClusterManager = [
  ...CommonPath,
  //GrainManager
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "ClusterManager",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/ClusterManager/ClusterManagerDashBoard",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "Ticket",
        path: "/ticket",
        componentPath: "pages/Dashboard/ClusterManager/Ticket",
        name: "Ticket",
        auth: false,
        exact: true,
      },
      {
        component: "ClusterManager",
        path: "/onboardings/cluster-manager",
        componentPath:
          "pages/Dashboard/ClusterManager/OnBoardings/ClusterManager",
        name: "ClusterManager",
        auth: false,
        exact: true,
      },
      {
        component: "AddClusterManager",
        path: "/onboardings/cluster-manager/add-cluster-manager",
        componentPath:
          "pages/Dashboard/ClusterManager/OnBoardings/AddClusterManager",
        name: "AddClusterManager",
        auth: false,
        exact: true,
      },
      {
        component: "AreaManager",
        path: "/onboardings/area-manager",
        componentPath: "pages/Dashboard/ClusterManager/OnBoardings/AreaManager",
        name: "AreaManager",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewAreaManager",
        path: "/onboardings/area-manager/add-new-area-manager",
        componentPath:
          "pages/Dashboard/ClusterManager/OnBoardings/AddNewAreaManager",
        name: "AddNewAreaManager",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/onboardings/location",
        componentPath: "pages/Dashboard/ClusterManager/OnBoardings/Location",
        name: "Location",
        auth: false,
        exact: true,
      },
      {
        component: "BDE",
        path: "/onboardings/business-devolpment-exective",
        componentPath:
          "pages/Dashboard/ClusterManager/OnBoardings/BusinessDevolpmentExecutive",
        name: "BDE",
        auth: false,
        exact: true,
      },
      {
        component: "AddBDE",
        path: "/onboardings/bde/add-bde",
        componentPath:
          "pages/Dashboard/ClusterManager/OnBoardings/AddBusinessDevolpmentExecutive",
        name: "AddBusinessDevolpmentExecutive",
        auth: false,
        exact: true,
      },
      {
        component: "Commodities",
        path: "/onboardings/commodities",
        componentPath: "pages/Dashboard/ClusterManager/OnBoardings/Commodities",
        name: "Commodities",
        auth: false,
        exact: true,
      },
      {
        component: "AddCommodities",
        path: "/onboardings/commodities/add-commodities",
        componentPath:
          "pages/Dashboard/ClusterManager/OnBoardings/AddCommodities",
        name: "AddCommodities",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewLocation",
        path: "/onboardings/location/add-new-location",
        componentPath:
          "pages/Dashboard/ClusterManager/OnBoardings/AddNewLocation",
        name: "AddNewLocation",
        auth: false,
        exact: true,
      },
      {
        component: "Supplier",
        path: "/onboardings/supplier",
        componentPath: "pages/Dashboard/ClusterManager/OnBoardings/Supplier",
        name: "Supplier",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewSupplier",
        path: "/onboardings/supplier/add-new-supplier",
        componentPath:
          "pages/Dashboard/ClusterManager/OnBoardings/AddNewSupplier",
        name: "AddNewSupplier",
        auth: false,
        exact: true,
      },
      {
        component: "Customer",
        path: "/onboardings/customer",
        componentPath: "pages/Dashboard/ClusterManager/OnBoardings/Customer",
        name: "Customer",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewCustomer",
        path: "/onboardings/customer/add-new-customer",
        componentPath:
          "pages/Dashboard/ClusterManager/OnBoardings/AddNewCustomer",
        name: "AddNewCustomer ",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfilePageKYC",
        path: "/kycdetails",
        componentPath: "pages/Dashboard/User/MyProfileKYC",
        name: "MyProfilePageKYC",
        auth: false,
        exact: true,
      },
    ],
  },
];
export const routersBusinessHead = [
  ...CommonPath,
  //GrainManager
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "BusinessHead",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/BusinessHead/BusinessDashboardHead",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "Ticket",
        path: "/ticket",
        componentPath: "pages/Dashboard/BusinessHead/Ticket",
        name: "Ticket",
        auth: false,
        exact: true,
      },
      {
        component: "ClusterManager",
        path: "/onboardings/cluster-manager",
        componentPath:
          "pages/Dashboard/BusinessHead/OnBoardings/ClusterManager",
        name: "ClusterManager",
        auth: false,
        exact: true,
      },
      {
        component: "AddClusterManager",
        path: "/onboardings/cluster-manager/add-cluster-manager",
        componentPath:
          "pages/Dashboard/BusinessHead/OnBoardings/AddClusterManager",
        name: "AddClusterManager",
        auth: false,
        exact: true,
      },
      {
        component: "ZonalManager",
        path: "/onboardings/zonal-manager",
        componentPath: "pages/Dashboard/BusinessHead/OnBoardings/ZonalManager",
        name: "ZonalManager",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewZonalManager",
        path: "/onboardings/zonal-manager/add-new-zonal-manager",
        componentPath:
          "pages/Dashboard/BusinessHead/OnBoardings/AddNewZonalManager",
        name: "AddNewZonalManager",
        auth: false,
        exact: true,
      },
      {
        component: "BDE",
        path: "/onboardings/business-devolpment-exective",
        componentPath:
          "pages/Dashboard/BusinessHead/OnBoardings/BusinessDevolpmentExecutive",
        name: "BDE",
        auth: false,
        exact: true,
      },
      {
        component: "AddBDE",
        path: "/onboardings/bde/add-bde",
        componentPath:
          "pages/Dashboard/BusinessHead/OnBoardings/AddBusinessDevolpmentExecutive",
        name: "AddBusinessDevolpmentExecutive",
        auth: false,
        exact: true,
      },
      {
        component: "Commodities",
        path: "/onboardings/commodities",
        componentPath: "pages/Dashboard/BusinessHead/OnBoardings/Commodities",
        name: "Commodities",
        auth: false,
        exact: true,
      },
      {
        component: "AddCommodities",
        path: "/onboardings/commodities/add-commodities",
        componentPath:
          "pages/Dashboard/BusinessHead/OnBoardings/AddCommodities",
        name: "AddCommodities",
        auth: false,
        exact: true,
      },
      {
        component: "AreaManager",
        path: "/onboardings/area-manager",
        componentPath: "pages/Dashboard/BusinessHead/OnBoardings/AreaManager",
        name: "AreaManager",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewAreaManager",
        path: "/onboardings/area-manager/add-new-area-manager",
        componentPath:
          "pages/Dashboard/BusinessHead/OnBoardings/AddNewAreaManager",
        name: "AddNewAreaManager",
        auth: false,
        exact: true,
      },
      {
        component: "GrainManager",
        path: "/onboardings/grain-manager",
        componentPath: "pages/Dashboard/BusinessHead/OnBoardings/GrainManager",
        name: "GrainManager",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewGrainManager",
        path: "/onboardings/grain-manager/add-new-grain-manager",
        componentPath:
          "pages/Dashboard/BusinessHead/OnBoardings/AddNewGrainManager",
        name: "AddNewGrainManager",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/onboardings/location",
        componentPath: "pages/Dashboard/BusinessHead/OnBoardings/Location",
        name: "Location",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewLocation",
        path: "/onboardings/location/add-new-location",
        componentPath:
          "pages/Dashboard/BusinessHead/OnBoardings/AddNewLocation",
        name: "AddNewLocation",
        auth: false,
        exact: true,
      },
      {
        component: "Customer",
        path: "/onboardings/customer",
        componentPath: "pages/Dashboard/BusinessHead/OnBoardings/Customer",
        name: "Customer",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewCustomer",
        path: "/onboardings/customer/add-new-customer",
        componentPath:
          "pages/Dashboard/BusinessHead/OnBoardings/AddNewCustomer",
        name: "AddNewCustomer ",
        auth: false,
        exact: true,
      },
      {
        component: "Supplier",
        path: "/onboardings/supplier",
        componentPath: "pages/Dashboard/BusinessHead/OnBoardings/Supplier",
        name: "Supplier",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewSupplier",
        path: "/onboardings/supplier/add-new-supplier",
        componentPath:
          "pages/Dashboard/BusinessHead/OnBoardings/AddNewSupplier",
        name: "AddNewSupplier",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfilePageKYC",
        path: "/kycdetails",
        componentPath: "pages/Dashboard/User/MyProfileKYC",
        name: "MyProfilePageKYC",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routersGrainDepositor = [
  ...CommonPath,
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "GrainDepositor",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath:
          "pages/Dashboard/GrainDepositor/Dashboard/GrainDepositorDashboard",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/dashboard/reservation-history",
        componentPath:
          "pages/Dashboard/GrainDepositor/Dashboard/ReservationHistory",
        name: "ReservationHistory",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/dashboard/agreement-execute",
        componentPath:
          "pages/Dashboard/GrainDepositor/Dashboard/AgreementExecuted",
        name: "AgreementExecuted",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/dashboard/stock-report",
        componentPath: "pages/Dashboard/GrainDepositor/Dashboard/StockReport",
        name: "StockReport",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/dashboard/warehouse-receipt-request",
        componentPath:
          "pages/Dashboard/GrainDepositor/Dashboard/WareHouseReceiptRequest",
        name: "WareHouseReceiptRequest",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/dashboard/outstanding-invoice",
        componentPath:
          "pages/Dashboard/GrainDepositor/Dashboard/OutstandingInvoice",
        name: "OutstandingInvoice",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/dashboard/overall-ledger",
        componentPath: "pages/Dashboard/GrainDepositor/Dashboard/OverAllLedger",
        name: "OverAllLedger",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/banking",
        componentPath: "pages/Dashboard/GrainDepositor/Banking",
        name: "Banking",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/myagents",
        componentPath: "pages/Dashboard/GrainDepositor/MyAgents",
        name: "MyAgents",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/payment",
        componentPath: "pages/Dashboard/GrainDepositor/Payments",
        name: "Payments",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/warehouse",
        componentPath: "pages/Dashboard/GrainDepositor/Warehouse",
        name: "Warehouse",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/quotation",
        componentPath: "pages/Dashboard/GrainDepositor/Quotation",
        name: "Quotation",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/certificates",
        componentPath: "pages/Dashboard/GrainDepositor/Certificates",
        name: "Certificates",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/customer-care",
        componentPath: "pages/Dashboard/GrainDepositor/CustomerCare",
        name: "CustomerCare",
        auth: false,
        exact: true,
      },
      {
        component: "Dashboard",
        path: "/tickets",
        componentPath: "pages/Dashboard/GrainDepositor/Tickets",
        name: "tickets",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routersCogOnboarding = [
  ...CommonPath,
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "CogOnboarding",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      // DASHBOARD
      {
        component: "Dashboard",
        path: "/dashboard",
        componentPath: "pages/Dashboard/CogOnboarding/COGOnboardingDashBoard",
        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
      {
        component: "Customers",
        path: "/customer",
        componentPath: "pages/Dashboard/CogOnboarding/Customers",
        name: "CustomersPage",
        auth: false,
        exact: true,
      },
      {
        component: "Customers",
        path: "/customer/add-customer",
        componentPath: "pages/Dashboard/CogOnboarding/AddEditCustomer",
        name: "AddEditCustomerPage",
        auth: false,
        exact: true,
      },
      {
        component: "Customers",
        path: "/customer/edit-customer",
        componentPath: "pages/Dashboard/CogOnboarding/AddEditCustomer",
        name: "AddEditCustomerPage",
        auth: false,
        exact: true,
      },
      {
        component: "Warehouses",
        path: "/warehouses",
        componentPath: "pages/Dashboard/CogOnboarding/Warehouses",
        name: "WarehousesPage",
        auth: false,
        exact: true,
      },
      {
        component: "Warehouses",
        path: "/warehouses/add-warehouse",
        componentPath: "pages/Dashboard/CogOnboarding/AddEditWarehouse",
        name: "AddNewWarehousePage",
        auth: false,
        exact: true,
      },
      {
        component: "Warehouses",
        path: "/warehouses/edit-warehouse",
        componentPath: "pages/Dashboard/CogOnboarding/AddEditWarehouse",
        name: "AddNewWarehousePage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location",
        componentPath: "pages/Dashboard/CogOnboarding/Location/Location",
        name: "LocationPage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/add-location",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditLocation",
        name: "AddEditLocationPage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/edit-location",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditLocation",
        name: "AddEditLocationPage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/add-cluster",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditCluster",
        name: "AddEditClusterPage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/edit-cluster",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditCluster",
        name: "AddEditClusterPage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/add-area",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditArea",
        name: "AddEditAreaPage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/edit-area",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditArea",
        name: "AddEditAreaPage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/add-zone",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditZone",
        name: "AddEditZonePage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/edit-zone",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditZone",
        name: "AddEditZonePage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/add-state",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditState",
        name: "AddEditStatePage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/edit-state",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditState",
        name: "AddEditStatePage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/add-district",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditDistrict",
        name: "AddEditDistrictPage",
        auth: false,
        exact: true,
      },
      {
        component: "Location",
        path: "/location/edit-district",
        componentPath: "pages/Dashboard/CogOnboarding/Location/AddEditDistrict",
        name: "AddEditDistrictPage",
        auth: false,
        exact: true,
      },
      {
        component: "ManPower",
        path: "/manpower",
        componentPath: "pages/Dashboard/CogOnboarding/ManPower",
        name: "ManPowerPage",
        auth: false,
        exact: true,
      },
      {
        component: "AddManpowerPage",
        path: "/manpower/add-new-manpower",
        componentPath: "pages/Dashboard/CogOnboarding/AddManpowerPage",
        name: "AddManpowerPage",
        auth: false,
        exact: true,
      },
      {
        component: "VendorPage",
        path: "/vendor",
        componentPath: "pages/Dashboard/CogOnboarding/VendorPage",
        name: "VendorPage",
        auth: false,
        exact: true,
      },
      {
        component: "InsurancePolicy",
        path: "/insurance-policy",
        componentPath: "pages/Dashboard/CogOnboarding/InsurancePolicy",
        name: "InsurancePolicyPage",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityList",
        path: "/commodity-list",
        componentPath: "pages/Dashboard/CogOnboarding/CommodityList",
        name: "CommodityListPage",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewVendorPage",
        path: "/vendor/add-vendor",
        componentPath: "pages/Dashboard/CogOnboarding/AddNewVendorPage",
        name: "AddNewVendorPage",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewVendorPage",
        path: "/vendor/edit-vendor",
        componentPath: "pages/Dashboard/CogOnboarding/AddNewVendorPage",
        name: "AddNewVendorPage",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewWSPPage",
        path: "/vendor/add-wsp",
        componentPath: "pages/Dashboard/CogOnboarding/AddNewWSPPage",
        name: "AddNewWSPPage",
        auth: false,
        exact: true,
      },
      {
        component: "AddNewWSPPage",
        path: "/vendor/edit-wsp",
        componentPath: "pages/Dashboard/CogOnboarding/AddNewWSPPage",
        name: "AddNewWSPPage",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityList",
        path: "/commodity-list/add-variety",
        componentPath:
          "pages/Dashboard/CogOnboarding/CommodityList/AddEditVariety",
        name: "AddEditVarietyPage",
        auth: false,
        exact: true,
      },

      {
        component: "CommodityList",
        path: "/commodity-list/edit-variety",
        componentPath:
          "pages/Dashboard/CogOnboarding/CommodityList/AddEditVariety",
        name: "AddEditVarietyPage",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityList",
        path: "/commodity-list/add-commodity",
        componentPath:
          "pages/Dashboard/CogOnboarding/CommodityList/AddEditCommodity",
        name: "AddEditCommodityPage",
        auth: false,
        exact: true,
      },
      {
        component: "CommodityList",
        path: "/commodity-list/edit-commodity",
        componentPath:
          "pages/Dashboard/CogOnboarding/CommodityList/AddEditCommodity",
        name: "AddEditCommodityPage",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "Privacy",
        path: "/setting/privacy",
        componentPath: "pages/Dashboard/SettingsPage/Privacy",
        name: "Privacy",
        auth: false,
        exact: true,
      },
      {
        component: "TermsAndCondition",
        path: "/setting/termsandcondition",
        componentPath: "pages/Dashboard/SettingsPage/TermsAndCondition",
        name: "TermsAndCondition",
        auth: false,
        exact: true,
      },
      {
        component: "ResetPass",
        path: "/setting/reset-password",
        componentPath: "pages/Dashboard/SettingsPage/ResetPass",
        name: "ResetPass",
        auth: false,
        exact: true,
      },
    ],
  },
];

export const routersFinanceTeamMember = [
  ...CommonPath,
  //Cog
  {
    component: "MainLayout",
    path: "/admin",
    auth: false,
    name: "FinanceTeamMember",
    exact: false,
    redirect: "/admin/dashboard",
    childrens: [
      {
        component: "Dashboard",
        path: "/dashboard",
        // componentPath: "pages/Dashboard/FinanceTeamMember/dashboard",
        // for pre-prod release
        componentPath: "pages/Dashboard/Cog/COGDashBoard",

        name: "Dashboard",
        auth: false,
        exact: true,
      },
      {
        component: "AllTransactions",
        path: "/value-chain-manage/all-transactions",
        componentPath: "pages/Dashboard/FinanceTeamMember/AllTransactions",
        name: "AllTransactions",
        auth: false,
        exact: true,
      },
      {
        component: "ReleaseRate",
        path: "/value-chain-manage/release-rate",
        componentPath: "pages/Dashboard/FinanceTeamMember/ReleaseRate",
        name: "ReleaseRate",
        auth: false,
        exact: true,
      },
      {
        component: "Deposits",
        path: "/value-chain-manage/deposits",
        componentPath: "pages/Dashboard/FinanceTeamMember/Deposits",
        name: "Deposits",
        auth: false,
        exact: true,
      },
      {
        component: "Invoice",
        path: "/value-chain-manage/invoice",
        componentPath: "pages/Dashboard/FinanceTeamMember/Invoice",
        name: "Invoice",
        auth: false,
        exact: true,
      },
      {
        component: "Setting",
        path: "/setting",
        componentPath: "pages/Dashboard/SettingsPage/Setting",
        name: "Setting",
        auth: false,
        exact: true,
      },
      {
        component: "MyProfile",
        path: "/myprofile",
        componentPath: "pages/Dashboard/User/MyProfile",
        name: "MyProfile",
        auth: false,
        exact: true,
      },
    ],
  },
];
